import { createContext, useContext, useEffect, useState } from "react";
import { t as _t } from "./translations";

const I18nCtx = createContext(null);

export function I18nProvider({ children, initialLang = "en" }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("tb_lang") || initialLang;
    } catch {
      return initialLang;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("tb_lang", lang);
    } catch {
      /* noop */
    }
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = (path, vars) => {
    let v = _t(lang, path);
    if (vars && typeof v === "string") {
      v = v.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? String(vars[k]) : m));
    }
    return v;
  };
  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>
  );
}

export function useI18n() {
  return useContext(I18nCtx);
}
